import i18n from '@/plugins/i18n'
import i18nCountries from 'i18n-iso-countries'

i18nCountries.registerLocale(require('i18n-iso-countries/langs/en.json'))
i18nCountries.registerLocale(require('i18n-iso-countries/langs/de.json'))
i18nCountries.registerLocale(require('i18n-iso-countries/langs/ru.json'))
i18nCountries.registerLocale(require('i18n-iso-countries/langs/es.json'))

export const countries = Object.entries(i18nCountries.getNames(i18n.locale)).map(
  ([code, name]) => ({ name, code })
)
